import moment from 'moment';
import { getIntl } from 'umi';

const DATE_RANGE_VALUES = {
  today: [moment(), moment()],
  yesterday: [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
  l7d: [moment().subtract(7, 'day'), moment()],
  l30d: [moment().subtract(30, 'day'), moment()],
  month: [moment().startOf('month'), moment().endOf('month')],
  year: [moment().startOf('year'), moment().endOf('year')],
  lm: [
    moment().subtract(1, 'months').startOf('month'),
    moment().subtract(1, 'months').endOf('month'),
  ],
  l3m: [
    moment().subtract(3, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  l6m: [
    moment().subtract(6, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  l12m: [
    moment().subtract(12, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  custom: [],
};

const getDateRange = () => [
  { key: 'today', label: getIntl().formatMessage({ id: 'global.text.today' }), value: 'today' },
  {
    key: 'yesterday',
    label: getIntl().formatMessage({ id: 'global.text.yesterday' }),
    value: 'yesterday',
  },
  { key: 'l7d', label: getIntl().formatMessage({ id: 'global.text.last7Days' }), value: 'l7d' },
  { key: 'l30d', label: getIntl().formatMessage({ id: 'global.text.last30Days' }), value: 'l30d' },
  {
    key: 'month',
    label: getIntl().formatMessage({ id: 'global.text.currentMonth' }),
    value: 'month',
  },
  { key: 'year', label: getIntl().formatMessage({ id: 'global.text.currentYear' }), value: 'year' },
  { key: 'lm', label: getIntl().formatMessage({ id: 'global.text.lastMonth' }), value: 'lm' },
  { key: 'l3m', label: getIntl().formatMessage({ id: 'global.text.last3Months' }), value: 'l3m' },
  { key: 'l6m', label: getIntl().formatMessage({ id: 'global.text.last6Months' }), value: 'l6m' },
  {
    key: 'l12m',
    label: getIntl().formatMessage({ id: 'global.text.last12Months' }),
    value: 'l12m',
  },
  {
    key: 'custom',
    label: getIntl().formatMessage({ id: 'global.text.customRange' }),
    value: 'custom',
  },
];

const CoreDates = (() => {
  return {
    DATE_RANGE_VALUES,
    get DATE_RANGE() {
      return getDateRange();
    },
  };
})();

export default CoreDates;
